<div *ngIf="siteAlerts">
  <div edsGrid *ngFor="let siteAlert of siteAlerts">
    <div class="container--wide">
      <div edsRow edsSpacing edsPadding edsPaddingTop="lg">
        <div edsCol>
          <eds-notifications
            [hasBorders]="true"
            [hasBorderRadius]="false"
            [hasShadows]="false"
            [hasIcon]="true"
            [inline]="false"
            [title]="siteAlert.notificationDetails.title"
            [CTAText]="siteAlert.notificationDetails.ctaText"
            [actionTarget]="siteAlert.notificationDetails.actionTarget"
            [isExternal]="siteAlert.notificationDetails.isExternal"
            [body]="siteAlert.notificationDetails.notificationLabel"
            [notificationType]="siteAlert.notificationDetails.notificationType"
            [canClose]="siteAlert.notificationDetails.canClose"
            [primaryBtnText]="
              siteAlert.notificationDetails.primaryBtnData.displayText
            "
            [isPrimaryBtnExternal]="
              siteAlert.notificationDetails.primaryBtnData.external
            "
            [primaryBtnActionTarget]="
              siteAlert.notificationDetails.primaryBtnData.url
            "
            [secondaryBtnText]="
              siteAlert.notificationDetails.secondaryBtnData.displayText
            "
            [isSecondaryBtnExternal]="
              siteAlert.notificationDetails.secondaryBtnData.external
            "
            [secondaryBtnActionTarget]="
              siteAlert.notificationDetails.secondaryBtnData.url
            "
            [tertiaryBtnText]="
              siteAlert.notificationDetails.tertiaryBtnData.displayText
            "
            [isTertiaryBtnExternal]="
              siteAlert.notificationDetails.tertiaryBtnData.external
            "
            [tertiaryBtnActionTarget]="
              siteAlert.notificationDetails.tertiaryBtnData.url
            "
            (btnSubscribe)="processClick($event, siteAlert.notificationDetails)"
            (closeEvent)="closeSiteAlert(siteAlert.notificationDetails)"
          >
          </eds-notifications>
        </div>
      </div>
    </div>
  </div>
</div>
